//#region types
import { Answer, Question } from "models/propTypes/genericFormProps";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { WintSuperkollAPIModelQuestionsAndAnswers } from "wint-api-client/dist/types";
//#endregion
import { UtilsHelper, FormHelper } from "utils/helpers";

function useDynamicFormSubmit() {
  const getFieldValue = (values: any, questionId?: string) =>
    questionId ? values[FormHelper.getDynamicFormFieldName(questionId)] : undefined;

  const getAnswer = (question: Question, value: any): Answer => {
    return {
      questionId: question.id,
      sectionId: question.sectionId,
      kind: question.answerKind,
      booleanValue:
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.Boolean && value !== undefined
          ? !!value
          : undefined,
      fileValue:
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.File && value?.length
          ? (value as UploadedFile[])?.map(
              (v): WintSuperkollAPIModelQuestionsAndAnswers.FileAnswerFileModel => ({
                fileId: v.id as string,
                fileName: v.fileName,
                mediaType: v.contentType,
                fileContent: v.data,
              })
            )
          : undefined,
      matrixValue:
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.Matrix
          ? (value as any[]).flatMap((row, rowIndex) => {
              return Object.entries(row).flatMap(([key, value]) => {
                const columnDefinition = question?.matrixDefinition?.questionMatrixColumnDefinitions?.find(
                  (c) => c.ordinal === Number(key)
                );
                if (columnDefinition) {
                  return {
                    textValue:
                      columnDefinition?.valueKind ===
                      WintSuperkollAPIModelQuestionsAndAnswers.QuestionMatrixValueKind.Text
                        ? (value as string)
                        : undefined,
                    booleanValue:
                      columnDefinition?.valueKind ===
                      WintSuperkollAPIModelQuestionsAndAnswers.QuestionMatrixValueKind.Boolean
                        ? (value as boolean)
                        : undefined,
                    numericValue:
                      columnDefinition?.valueKind ===
                      WintSuperkollAPIModelQuestionsAndAnswers.QuestionMatrixValueKind.Numeric
                        ? (value as number)
                        : undefined,
                    rowOrdinal: rowIndex + 1,
                    columnOrdinal: Number(key),
                  };
                } else return [];
              });
            })
          : undefined,
      selectionValue:
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.Selection &&
        UtilsHelper.notUndefinedOrNull(value)
          ? Array.isArray(value)
            ? value
            : [value]
          : undefined,
      stringSelectionValue:
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.StringSelection &&
        UtilsHelper.notUndefinedOrNull(value)
          ? Array.isArray(value)
            ? typeof value === "string"
              ? value
              : value.map((m) => m.id)
            : [value]
          : undefined,
      numericValue:
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.Numeric
          ? (value as number)
          : undefined,
      textValue:
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.Text ||
        question?.answerKind === WintSuperkollAPIModelQuestionsAndAnswers.AnswerKind.SingleLineText
          ? (value as string)
          : undefined,
    };
  };

  return { getFieldValue, getAnswer };
}

export default useDynamicFormSubmit;
